module.exports = __webpack_public_path__ + "static/tfbusdlogo-b6d1fd6e3f9b2c0f2fe2c3f36e8a1e47.svg";